/* ================================
   PRODUCT MODEL WEB COMPONENT
   ================================ */

(function () {
  if (customElements.get('product-model')) return;

  class ProductModel extends HTMLElement {
    constructor() {
      super();

      this.poster = this.querySelector('[id^="Deferred-Poster-"]');
      this.template = this.querySelector('template');
      this.modelViewer = null;
      this.modelViewerUI = null;

      if (!this.poster || !this.template) return;

      this.onPosterClick = this.onPosterClick.bind(this);
      this.poster.addEventListener('click', this.onPosterClick);
    }

    onPosterClick() {
      this.loadModel();
    }

    loadModel() {
      if (this.modelViewer) return;

      window.pauseAllMedia?.();

      const content = this.template.content.firstElementChild;
      if (!content) return;

      this.modelViewer = content.cloneNode(true);
      this.appendChild(this.modelViewer);

      this.poster.classList.add('hidden');

      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.onModelViewerUILoad.bind(this)
        }
      ]);
    }

    onModelViewerUILoad(errors) {
      if (errors || !this.modelViewer) return;

      this.modelViewerUI = new Shopify.ModelViewerUI(this.modelViewer);
    }
  }

  customElements.define('product-model', ProductModel);
})();

/* ================================
   SHOPIFY XR SUPPORT
   ================================ */

(function () {
  window.ProductModel = {
    loadShopifyXR() {
      if (!window.Shopify || !Shopify.loadFeatures) return;

      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this)
        }
      ]);
    },

    setupShopifyXR(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () =>
          this.setupShopifyXR()
        );
        return;
      }

      document
        .querySelectorAll('[id^="ProductJSON-"]')
        .forEach((modelJSON) => {
          try {
            ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
          } catch (e) {}
          modelJSON.remove();
        });

      ShopifyXR.setupXRElements();
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.ProductModel?.loadShopifyXR();
  });
})();